import { useMutation } from '@tanstack/react-query';
import { forwardInvoice } from '../service';

export function useInvoiceForward({
    onSuccess = () => {},
    onError = () => {},
}: {
    onSuccess?: () => void;
    onError?: (error: Error) => void;
} = {}) {
    const mutation = useMutation({
        mutationFn: async ({
            invoiceId,
            toAddresses,
            ccAddresses,
            message,
        }: {
            invoiceId: number;
            toAddresses: string[];
            ccAddresses: string[];
            message: string | null;
        }) => {
            await forwardInvoice(
                invoiceId,
                toAddresses,
                ccAddresses,
                message
            );
        },
        onSuccess,
        onError,
    });

    return mutation;
}
